import axios from 'axios';

export const registerUser = async ({email, password, captchaToken}) => {
  const response = await axios.post('/auth/register', {
    email,
    password,
    captchaToken
  });

  return response;
};

export const loginUser = async (email, password, captchaToken) => {
  const response = await axios.post('/auth/login', {
    email,
    password,
    captchaToken
  });

  return response;
};

export const resetPassword = async (email, captchaToken) => {
  const response = await axios.post('/auth/reset-password', {
    email,
    captchaToken
  });

  return response;
};

export const changePassword = async (currentPassword, newPassword) => {
  const response = await axios.post('/auth/change-password', {
    currentPassword,
    newPassword,
  });

  return response;
};

export const loginUserAdmin = async (id) => {
  const response = await axios.get(`/auth/login-admin/${id}`);

  return response;
};
